import { Temporal } from './temporal'
import { DateTime } from 'luxon'
import { assertNotNullOrUndefined } from '../tsUtils'
import { Nullable } from '../typesUtils'
import { TimeFormat } from './model/date'

/**
 * Méthode permettant de manipuler uniquement la partie time d'un objet {@link Date} js. <br>
 * Cette classe est sérializable, donc elle peut directement être envoyée au back.
 */
export class LocalTime extends Temporal {
	public static fromAPI(temporal: string): LocalTime
	public static fromAPI(temporal: undefined): undefined
	public static fromAPI(temporal: null): null
	public static fromAPI(temporal: string | undefined): LocalTime | undefined
	public static fromAPI(temporal: string | null): LocalTime | null
	public static fromAPI(temporal: Nullable<string>): Nullable<LocalTime>
	public static fromAPI(temporal: Nullable<string>): Nullable<LocalTime> {
		if (assertNotNullOrUndefined(temporal)) {
			return new LocalTime(DateTime.now().setZone(Temporal.API_TIMEZONE).set(Temporal._splitTime(temporal)))
		}
		return temporal
	}

	public static fromJS = (date: Date): LocalTime => new LocalTime(DateTime.fromJSDate(date, { zone: Temporal.API_TIMEZONE }))

	public static fromCalendar = (date: string | object | Date): LocalTime => {
		if (date instanceof Date) {
			return LocalTime.fromJS(date)
		}
		if (typeof date === 'string') {
			return LocalTime.fromAPI(date)
		}
		if (date instanceof LocalTime) {
			return date
		}
		console.error('Type inconnu', date)
		throw new Error(`Type inconnu ${typeof date}`)
	}

	public static now = (): LocalTime => new LocalTime(DateTime.now().setZone(Temporal.API_TIMEZONE))

	public format = (timeFormat: TimeFormat = TimeFormat.TIME_24_WITH_SECONDS): string => this.toDisplayDate(timeFormat, undefined)

	public today = (): Date => this._date.toJSDate()

	public toJSON(): string {
		return this.format()
	}
}
